import { render, staticRenderFns } from "./BaseButtonPrimaryExtraSmall.vue?vue&type=template&id=1cbc7331&"
import script from "./BaseButtonPrimaryExtraSmall.vue?vue&type=script&lang=js&"
export * from "./BaseButtonPrimaryExtraSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports